/*
==========================================
Rootslane Toast
Version 1
==========================================
*/

(() => {

    "use strict";

    window.RootslaneToast = {

        container: null,

        timer: null,

        init() {

            if (this.container) return;

            this.container =
                document.createElement("div");

            this.container.className =
                "rl-toast";

            document.body.appendChild(
                this.container
            );

        },

        show(message, duration = 2500) {

            this.init();

            clearTimeout(this.timer);

            this.container.textContent =
                message;

            this.container.classList.add(
                "show"
            );

            this.timer = setTimeout(() => {

                this.container.classList.remove(
                    "show"
                );

            }, duration);

        }

    };

})();